import { ROLE_NAMESPACE } from "../config/products";

interface AuthUserWithRoles {
  [ROLE_NAMESPACE]?: unknown;
}

export const getUserRoles = (user: unknown): string[] => {
  const roles = (user as AuthUserWithRoles | undefined)?.[ROLE_NAMESPACE];
  return Array.isArray(roles)
    ? roles.filter((role): role is string => typeof role === "string")
    : [];
};

export const isAdminUser = (user: unknown) => getUserRoles(user).includes("admin");
